import React from 'react';

// Componente para a seção "Tecnologias"
const Tecnologias: React.FC = () => {
  return (
    <section id="tecnologias" className="py-20 bg-gray-50 dark:bg-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="section-title">Tecnologias que dominamos</h2>
          <p className="section-subtitle">
            Utilizamos as mais avançadas tecnologias para transformar dados em insights valiosos 
            e impulsionar a inovação em seu negócio.
          </p>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Tecnologia 1 */}
          <div className="card group hover:bg-lupa-orange/5 dark:hover:bg-lupa-orange/10 transition-all duration-300">
            <div className="text-lupa-orange mb-6">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-3">Data Lakehouse</h3>
            <p className="text-gray-600 dark:text-gray-300">
              Combinamos o melhor dos data lakes e data warehouses para criar uma arquitetura 
              unificada que oferece flexibilidade, escalabilidade e performance.
            </p>
          </div>
          
          {/* Tecnologia 2 */}
          <div className="card group hover:bg-lupa-orange/5 dark:hover:bg-lupa-orange/10 transition-all duration-300">
            <div className="text-lupa-orange mb-6">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-3">Inteligência Artificial</h3>
            <p className="text-gray-600 dark:text-gray-300">
              Desenvolvemos e implementamos soluções de IA que automatizam processos, 
              identificam padrões e geram insights preditivos para seu negócio.
            </p>
          </div>
          
          {/* Tecnologia 3 */}
          <div className="card group hover:bg-lupa-orange/5 dark:hover:bg-lupa-orange/10 transition-all duration-300">
            <div className="text-lupa-orange mb-6">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-3">Machine Learning</h3>
            <p className="text-gray-600 dark:text-gray-300">
              Criamos modelos de aprendizado de máquina que evoluem continuamente, 
              melhorando a precisão das previsões e a eficiência dos processos.
            </p>
          </div>
          
          {/* Tecnologia 4 */}
          <div className="card group hover:bg-lupa-orange/5 dark:hover:bg-lupa-orange/10 transition-all duration-300">
            <div className="text-lupa-orange mb-6">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-3">Big Data</h3>
            <p className="text-gray-600 dark:text-gray-300">
              Implementamos infraestruturas robustas para processar, armazenar e analisar 
              grandes volumes de dados com eficiência e segurança.
            </p>
          </div>
          
          {/* Tecnologia 5 */}
          <div className="card group hover:bg-lupa-orange/5 dark:hover:bg-lupa-orange/10 transition-all duration-300">
            <div className="text-lupa-orange mb-6">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-3">Data Analytics</h3>
            <p className="text-gray-600 dark:text-gray-300">
              Transformamos dados brutos em visualizações intuitivas e relatórios 
              acionáveis que facilitam a tomada de decisões estratégicas.
            </p>
          </div>
          
          {/* Tecnologia 6 */}
          <div className="card group hover:bg-lupa-orange/5 dark:hover:bg-lupa-orange/10 transition-all duration-300">
            <div className="text-lupa-orange mb-6">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-3">Segurança de Dados</h3>
            <p className="text-gray-600 dark:text-gray-300">
              Implementamos protocolos avançados de segurança para proteger seus dados 
              contra ameaças e garantir conformidade com regulamentações.
            </p>
          </div>
        </div>
        
        <div className="mt-16 text-center">
          <a href="#contato" className="btn-primary inline-block">Entenda como podemos ajudar seu negócio</a>
        </div>
      </div>
    </section>
  );
};

export default Tecnologias;
